import { handleResponse } from '../Helpers/handle-response';
import * as apiHelper from '../Helpers/apiHelper';
import { toDateFormatWithoutT } from '../Helpers/dateHelper';

export const dataService = {
    getProductionOrdersByMachine,
    getProductionOrdersBySearchText,
    getOrderDetailsByOrderId,
    getSystemParameterById,
    getMachineInAssignedByMachineId,
    getMachinesWithScissorStatusInfo,
    assignQuantityAtMachine,
    deleteMachineInAssignedById,
    updateZones,
    startProductionOrder,
    pauseProductionOrder,
    stopProductionOrder,
    finishProductionOrder,
    getMaterials,
    getArticles,
    pauseOrderById,
    startOrderById,
    getProductionOrderLineBOMOutProducedByBOMOutId,
    createBookingForProductionOrder,
    getQualitySamplesByBarcode,
    saveQualitySamples,
    getQualitySamplesByProductionOrderId,
    GetCheckNumberForPallet,
    machineStoppedReason,
    saveNotification,
    getLatestNotifications,
    GetBookingSequenceByProductionOrderIdAndBarcode,
    GetLastWeight,
    getTransportOrdersHistory,
    getActiveTransportOrders,
    createNewBooking,
    getMachineSettingsByMachineId,
    saveMachineSetting,
    getOperators,
    getMachineParameters,
    getMachinesByMachineType,
    getSilos,
    getQualityChecks,
    getQualityCheckTypes,
    getQualityCheckOrders,
    getRestrictions,
    getWorkingHours,
    getRestrictionTypes,
    deleteProductionOrderById,
    createProductionOrder,
    updateProductionOrder,
    updateProductionOrderMetaData,
    getAllProducts,
    getPlanningData,
    getAllProductionOrdersWithDetails,
    changeMachineStatus,
    getWorkstations,
    getShifts,
    getProgressions,
    getWorkstationStatusses,
    getProgressByProductionOrderId
};

//in backend => order by ScheduledOn
function getProductionOrdersByMachine(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PRODUCTIONORDERSBYMACHINE);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getProductionOrdersBySearchText(searchText) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PRODUCTIONORDERSBYSEARCHTEXT);
    url += `?searchText=${searchText}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getOrderDetailsByOrderId(Id) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_ORDERDETAILS);
    url += `?Id=${Id}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getSystemParameterById(systemParameterId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SYTEMPARAMETER);
    url += `?systemParameterId=${systemParameterId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function assignQuantityAtMachine(machineId, productId, quantity, silo, purchaseOrderNumber) {
    if (silo === "") {
        silo = null
    }
    else {
        silo = "\"" + silo + "\""
    }
    if (purchaseOrderNumber === "") {
        purchaseOrderNumber = null
    }
    else {
        purchaseOrderNumber = "\"" + purchaseOrderNumber + "\""
    }
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            machineId: machineId,
            quantityAssigned: parseFloat(quantity),
            metaData: "[{\"MetaDataType\":1, \"Version\": 1,\"MetaData\":[{\"ProductId\": " + productId + ",\"Silo\": " + silo + ",\"PurchaseOrderNumber\": " + purchaseOrderNumber + "}]}]"
           
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_ASSIGNQUANTITYATMACHINE);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getMachineInAssignedByMachineId(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETMACHINEINASSIGNEDBYMACHINEID);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function deleteMachineInAssignedById(Id) {
    const requestOptions = {
        method: 'DELETE', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_DELETEMACHINEINASSIGNEDBYID);
    url += `${Id}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getMachinesWithScissorStatusInfo() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_MACHINESWITHSCISSORSTATUSINFO);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function updateZones(metaData, productionOrderId,machineIdPlanned) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            productionOrderId: productionOrderId,
            metaData: metaData,
            machineIdPlanned : machineIdPlanned           
        })
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_UPDATEZONES);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function startProductionOrder(productionOrderId,selectedWorkstation) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
       
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_STARTPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;
    url += `&selectedMachineId=${selectedWorkstation}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function pauseProductionOrder(productionOrderId) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
       
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PAUSEPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function stopProductionOrder(productionOrderId) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_STOPPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function finishProductionOrder(productionOrderId) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
      
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_FINISHPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getProductionOrderLineBOMOutProducedByBOMOutId(bomOutId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPRODUCTIONORDERLINEBOMOUTPRODUCED);
    url += `?bomOutId=${bomOutId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function createBookingForProductionOrder(productionOrder,barcode,progress) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },      
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_CREATEBOOKING);
    url += `?productionOrderId=${productionOrder.id}`;
    url += `&barcode=${barcode}`;
    url += `&progress=${progress}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getMachineSettingsByMachineId(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETMACHINESETTINGSBYMACHINEID);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function saveMachineSetting(machineId, value, machineSettingId) {   

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },        
        body: JSON.stringify({
            MachineId: machineId,
            MachineSettingId: machineSettingId,
            Value: JSON.stringify(value)         
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEMACHINESETTINGS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function changeMachineStatus(stopMachine,plannedStop, machineId, upperScrap,lowerScrap) {   

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },        
        body: JSON.stringify({
            Language: 1,
            LineNumber: machineId,
            Stopped: stopMachine,
            PlannedStop:plannedStop,
            LowerScrap:lowerScrap,
            UpperScrap:upperScrap        
        })
    };

    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_CHANGEMACHINESTATUS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getQualitySamplesByBarcode(barcode,productionOrderId,productId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETQUALITYSAMPLESBYBARCODE);
    url += `?barcode=${barcode}`;
    url += `&productionOrderId=${productionOrderId}`;
    url += `&productId=${productId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function saveQualitySamples(qualitySamples,productionOrderId, machineCode) {
   
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            CarrierId: qualitySamples.carrierId,
            ProductionOrderId:productionOrderId,
            QualitySamples: qualitySamples.qualitySamples,
            MachineCode: machineCode
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEQUALITYSAMPLES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getQualitySamplesByProductionOrderId(productionOrderId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETQUALITYSAMPLESBYPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;  

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function machineStoppedReason(lineNumber,reasonId,machineReasonDescription,userName) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            Language: 1,
            LineNumber: lineNumber,
            ReasonId:reasonId,
            UserName:userName,
            MachineReasonDescription:machineReasonDescription
        })
    };

    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_MACHINESTOPPEDREASON);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function saveNotification(notificationTypeId,message, barcode, machineId,sampleSequence, productionOrderId,sampleId) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            NotificationTypeId: notificationTypeId,
            Message:message,
            Reference:{
                CarrierBarcode:barcode,
                MachineId:machineId,
                CheckNumber:sampleSequence,
                SampleId:sampleId,
                ProductionOrderReference: productionOrderId
            }
        })
    };

    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_SAVENOTIFICATION);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getLatestNotifications() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETLATESTNOTIFICATIONS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function GetCheckNumberForPallet(barcode) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETCHECKNUMBERFORPALLET);
    url += `?barcode=${barcode}`;  

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function GetBookingSequenceByProductionOrderIdAndBarcode(productionOrderId, barcode) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETBOOKINGSEQUENCE);
    url += `?productionOrderId=${productionOrderId}`;  
    url += `&barcode=${barcode}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function GetLastWeight() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_GETLASTWEIGHT);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getPlanningData() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPLANNINGDATA);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getAllProductionOrdersWithDetails() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLWITHDETAILS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getAllProducts() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_GETALLPRODUCTS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function updateProductionOrderMetaData(productionOrder) {
    const requestOptions = {
        method: 'PUT', headers: {
            'Content-Type': 'application/json',
        }, body: JSON.stringify(
            productionOrder
        )
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_UPDATEPRODUCTIONORDERMETADATA);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function updateProductionOrder(productionOrder) {
    const requestOptions = {
        method: 'PUT', headers: {
            'Content-Type': 'application/json',
        }, body: JSON.stringify(
            productionOrder
        )
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_UPDATEPRODUCTIONORDER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function createProductionOrder(maintenance, machineId, machineCodeToMaintain, reference, productId, quantity, salesOrder, client, start, end) {

    if (!machineCodeToMaintain) {
        machineCodeToMaintain = ""
    }
    if (!salesOrder) {
        salesOrder = ""
    }
    if (!client) {
        client = ""
    }
    if (!quantity) {
        quantity = 0
    }

    start = toDateFormatWithoutT(start)
    end = toDateFormatWithoutT(end)
    start = new Date(new Date(start).setHours(new Date(start).getHours() + 2))
    end = new Date(new Date(end).setHours(new Date(end).getHours() + 2))

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            Maintenance: maintenance,
            MachineId: machineId,
            MachineCodeToMaintain: machineCodeToMaintain,
            Reference: reference,
            ProductId: productId,
            QuantityToProduce: parseFloat(quantity),
            SalesOrder: salesOrder,
            Client: client,
            StartedOnPlanned: start,
            FinishedOnPlanned: end
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_CREATEPRODUCTIONORDER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function deleteProductionOrderById(productionOrderId) {
    const requestOptions = {
        method: 'DELETE', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_DELETEPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getProgressByProductionOrderId(productionOrderId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPROGRESSBYPRODUCTIONORDERID);
    url += `?productionOrderId=${productionOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

//Fake backend Calls
function getMaterials() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetMaterials', requestOptions).then(handleResponse);
}

function getArticles() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetArticles', requestOptions).then(handleResponse);
}

function pauseOrderById(id) {
    const requestOptions = { method: 'PUT' };
    return fetch('/Api/PauseOrderById?id=' + id, requestOptions).then(handleResponse);
}

function startOrderById(id) {
    const requestOptions = { method: 'PUT' };
    return fetch('/Api/StartOrderById?id=' + id, requestOptions).then(handleResponse);
}

function getActiveTransportOrders() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetActiveTransportOrders', requestOptions).then(handleResponse);
}

function getTransportOrdersHistory() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetTransportOrdersHistory', requestOptions).then(handleResponse);
}

function createNewBooking(newBooking) {
    const requestOptions = {
        method: 'POST', headers: {
            'Accept': 'application/json, text/plain, */*',
        },
        body: newBooking
    };
    return fetch('/Api/CreateNewBooking', requestOptions).then(handleResponse);
}

function getOperators() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetOperators', requestOptions).then(handleResponse);
}

function getMachineParameters() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetMachineParameters', requestOptions).then(handleResponse);
}

function getMachinesByMachineType(machineType) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };    

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_MACHINESBYMACHINETYPE);
    url += `?machineTypeId=${machineType}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getSilos() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetSilos', requestOptions).then(handleResponse);
}

function getQualityChecks() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetQualityChecks', requestOptions).then(handleResponse);
}

function getQualityCheckTypes() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetQualityCheckTypes', requestOptions).then(handleResponse);
}

function getQualityCheckOrders() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetQualityCheckOrders', requestOptions).then(handleResponse);
}

function getRestrictions() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetRestrictions', requestOptions).then(handleResponse);
}

function getShifts() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetShifts', requestOptions).then(handleResponse);
}

function getWorkingHours() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetWorkingHours', requestOptions).then(handleResponse);
}

function getWorkstations() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetWorkstations', requestOptions).then(handleResponse);
}


function getRestrictionTypes() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetRestrictionTypes', requestOptions).then(handleResponse);
}

function getProgressions() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetProgressions', requestOptions).then(handleResponse);
}


function getWorkstationStatusses(){
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetWorkstationStatusses', requestOptions).then(handleResponse);
}








